import { ok } from "@ps-bridge/ok";
import type { Ok } from "@ps-bridge/ok";
import type { OptionTs } from "@ps-bridge/interop";
import * as Option from "@utils/Option";

export const getRootContainer = (): OptionTs<HTMLElement> => {
  const container = document.getElementById("root");
  return container ? Option.some(container) : Option.none<HTMLElement>();
};

export const logMissingRootContainer = (): Ok => {
  console.error("Root container missing in index.html");
  return ok;
};
